module.exports = __webpack_public_path__ + "static/media/Flag-European-Union.047d23ba.webp";